import { render, staticRenderFns } from "./TableControl.vue?vue&type=template&id=48a23201"
import script from "./TableControl.vue?vue&type=script&lang=js"
export * from "./TableControl.vue?vue&type=script&lang=js"
import style0 from "./TableControl.vue?vue&type=style&index=0&id=48a23201&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports